import logo from '../logo.jpeg'
import './Logo.css'

const Logo = () => {
    return <div className='logo_container'>
        <img src={logo} alt='Arrow Hub Menu' height='20%' width='20%'/>
    </div>;
}
 
export default Logo;